export default "__VITE_ASSET__CW3zsJT8__"